import {
  ModalContextProvider,
  TableFacetContextProvider,
  TableFilterQueryParamContextProvider,
  TablePaginationContextProvider,
  TableSortContextProvider,
} from 'modules/experiments/contexts';
import 'modules/experiments/ducks/sagas';
import { ChooseCampaignTakeover } from 'modules/experiments/components/takeover/ChooseCampaignTakeover';

import { ExperimentsIndexPage } from './ExperimentsIndexPage';

export const ExperimentsIndexContext = () => {
  return (
    <TablePaginationContextProvider>
      <TableFilterQueryParamContextProvider>
        <TableFacetContextProvider>
          <TableSortContextProvider>
            <ModalContextProvider>
              <ExperimentsIndexPage />
              <ChooseCampaignTakeover
                onClose={() => {
                  /* refetch placeholder */
                }}
              />
            </ModalContextProvider>
          </TableSortContextProvider>
        </TableFacetContextProvider>
      </TableFilterQueryParamContextProvider>
    </TablePaginationContextProvider>
  );
};
